<template>
    <div class="recruitPages">
        <div class="recruitPages__container">
            <!--==== topbanner  ====-->
            <div class="recruitPages_topbanner">
                <section class="recruitBanner mainSite clearfix" role="home-topBanner">
                    <div class="carousel slide" id="recruitBanner" data-ride="carousel" data-pause="false">
                        <!-- Indicators -->

                        <div class="carousel-inner" role="listbox">
                            <div class="item first-slide active">
                                <a class="hold_link" onclick="" href="">
                                </a>
                                <img alt=""
                                    src="https://resource.rcclchina.com.cn/hr/DD_Wilson-Butler_Spectrum_View_06_Top_2018_06_06-FINAL.jpg">
                            </div>
                        </div>
                        <!-- /.carousel -->
                    </div>

                </section>
            </div>
            <!--==== 图片链接  ====-->
            <div class="recruitPages_picLists">
                <div class="recruitPages__title">
                    <div class="recruitPages__titleCon">
                        <div class="picLists__title_logo">
                            <img src="https://resource.rcclchina.com.cn/logo/PC/logoAnchorBlue.png">
                        </div>
                        <div class="picLists__title_logoTxt">
                            <p>开启你的皇家职业之旅</p>
                        </div>
                    </div>
                    <div class="recruitPages_qrCode">
                        <div class="recruitPages_qrCode-text">
                            扫描关注公司招聘公众号<br>了解更多职位详情
                        </div>
                        <div class="recruitPages_qrCode-image">
                            <img src="https://resource.rcclchina.com.cn/logo/PC/logoRecruitmentQRCode.png">
                        </div>
                    </div>
                </div>
                <div class="recruitPages_picLists__items">
                    <div class="item--body" v-for="city in cities" :key="('city_'+city.id)">
                        <a :href="getCitySearchLink(city.enName)" target="_blank">
                            <div class="item--name">
                                <p>{{city.name}}</p>
                            </div>
                            <div class="item--info">
                                <p></p>
                            </div>
                            <div class="item--pic">
                                <img :src="city.iconImage">
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <!--==== 文字链接 hot  ====-->
            <div class="recruitPages_hotLists" style="padding-bottom: 30px">
                <div class="recruitPages__title">
                    <div class="recruitPages__titleCon">
                        <div class="picLists__title_logo">
                            <img src="https://resource.rcclchina.com.cn/logo/PC/logoAnchorBlue.png">
                        </div>
                        <div class="picLists__title_logoTxt">
                            <p>热招职位</p>
                        </div>
                        <div class="picLists__HotPic">
                            <img src="https://resource.rcclchina.com.cn/Recruitment/HotPic.png">
                        </div>
                    </div>

                </div>
                <div class="recruitPages_hotLists__items">

                    <div class="hotLists__item">
                        <div class="item--Topdisplay item--title">
                            <p>职位名称</p>
                        </div>
                        <div class="item--Topdisplay item--department">
                            <p>部门</p>
                        </div>
                        <div class="item--Topdisplay item--location">
                            <p>城市</p>
                        </div>
                        <div class="item--Topdisplay item--date">
                            <p>发布日期</p>
                        </div>
                        <div class="item--Topdisplay item--applyBtn">
                            <p>我要应聘</p>
                        </div>
                    </div>

                    <div class="hotLists__item" v-for="(job, i) in topJobPositions" :key="('job_'+job.id)"
                     :class="{ 'hotListActive': i%2==0}">
                        <a :href="('Detail?position='+job.id)" target="_blank">
                            <div class="item--display item--title">
                                <p>{{job.title}}</p>
                            </div>
                            <div class="item--display item--department">
                                <p>{{job.department}}</p>
                            </div>
                            <div class="item--display item--location">
                                <p>{{job.cityName}}</p>
                            </div>
                            <div class="item--display item--date">
                                <p>{{getPublishTime(job.launchDate)}}</p>
                            </div>
                            <div class="item--display item--applyBtn">
                                <div class="hotLists__applyBtn">
                                    <p>我要应聘</p>
                                </div>
                            </div>
                        </a>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "RecruitmentIndex",
    data () {
        return {
            cities: [],
            topJobPositions: []
        }
    },
    beforeMount () {
        this.initPage()
    },
    methods: {
        async initPage() {
            const { success, data } = await api.page.getRecruitmentIndex()
            if (success && data) {
                this.cities = data.cities || []
                this.topJobPositions = data.jobPositions || []
            }
        },
        getCitySearchLink (cityName) {
            return `Search?cityName=${encodeURIComponent(cityName)}`
        },
        getPublishTime (time) {
            let publishTime = time + ''
            if (publishTime.length > 10) {
                publishTime = publishTime.substring(0, 10)
            }
            return publishTime.split('-').join('.')
        }
    }
}
</script>

<style lang="less" scoped>
.recruitPages a,.recruitPages a:hover,.recruitPages a:link
{
    text-decoration:none;
}


.recruitPages{
    width:100%;
	background:#f0f5ff;
}
.recruitPages__container {
    width:100%;
    min-width:1000px;
    background:#f0f5ff;
    padding:0px 15px;
}
/*topbanner*/
.recruitPages .recruitBanner .carousel-indicators{
    width:100%;
	bottom:24px !important;
	margin-bottom: 0px;
    background:none;
    left:0px;
    padding:0px;
    margin-left:0;
}
.recruitPages .recruitBanner .carousel{
	padding-bottom: 48px;
}
.recruitPages .recruitBanner .carousel-indicators li{
	width:146px;
	height:8px;
	background:#fff;
	border-radius: 0px;
	margin:0px 6px;
}
.recruitPages .recruitBanner .carousel-indicators .active{
	background: #001a55 !important;
}

/*图片链接*/
.recruitPages_picLists{
	width:100%;
}
.recruitPages__title{
	background:#e7efff;
	width:100%;
	padding:24px 0px;
	margin-bottom:26px;
    position: relative;
}
.recruitPages__titleCon{
	/*width:60.0833%;*/
    width:1000px;
	margin:0 auto;
}
.picLists__title_logo{
	width:43px;
	height:47px;
	display: inline-block;
}
.picLists__title_logo > img {
  height: 100%;
}
.picLists__title_logoTxt{
	display: inline-block;
    vertical-align:middle;
}
.picLists__title_logoTxt p{
	margin: 0;
	font-size: 24px;
	font-weight: bold;
    color:#000;
}
.recruitPages_picLists__items{
	/*width:60.0833%;*/
    width:1000px;
	margin:0 auto;
}
.item--body{
	width:30%;
	background:#fcfcfc;
	border:6px solid #ccc;
	padding:6px 10px;
	margin:0px 1% 22px 1%;
	display: inline-block;
	cursor: pointer;
}
.item--name{
}
.item--name p{
	font-size: 20px;
	color:#3e93c8;
	font-weight: bold;
}
.item--info{
}
.item--info p{
	color:#000;
	font-size: 18px;
}
.item--pic{
	width:100%;
}
.item--pic img{
	width:100%;
}
/*文字链接 hot*/
.recruitPages_hotLists{
	width:100%;
    padding-bottom: 30px;
}
.picLists__HotPic{
	width:67px;
	height:65px;
	float: right;
	margin-top:-24px;
	margin-right: 4%;
}
.recruitPages_hotLists__items{
	width: 100%;
}
.hotLists__item{
	/*width:60.0833%;*/
    width:1000px;
	margin:0px auto;
	margin-top: 10px;
	overflow: hidden;
	padding:10px 0px 10px 1%;
}
.item--Topdisplay,.item--display{
    margin-right: 5%;
    display: inline-block;
    text-align: left;
    font-weight:400;
}
.item--title{
	width:24%;
}
.item--department{
	width:24%;
}
.item--location{
	width:8%;
}
.item--date{
	width:10%;
	text-align: center;
}
.item--applyBtn{
	width:84px;
	text-align: center;
	cursor: pointer;
    float:right;
    margin-right:3%;
}
.item--Topdisplay p{
	font-size: 18px;
	font-weight: bold;
	color: #031356;
}
.item--display{
	font-size: 18px;
	color: #444;
    vertical-align:top;
    word-break:break-word;
}
.hotLists__applyBtn{
	height:34px;
	line-height: 32px;
	border:1px dotted #8f8f99;
	border-radius: 8px;
}
.hotLists__applyBtn p{
	color:#0070b7;
	margin:0;
}

.hotListActive{
	background: #eeefff;
}

/*公众号二维码*/
.recruitPages_qrCode {
    position: absolute;
    right: 5px;
    top: -13px;
}

.recruitPages_qrCode>div {
    display: inline-block;
    vertical-align: middle;
}

.recruitPages_qrCode-image {
    width: 120px;
}

.recruitPages_qrCode-image img {
    width: 100%;
}

.recruitPages_qrCode-text {
    font-size: 16px;
    color: black;
    text-align: center;
}


</style>
